import { ComponentsOverrides, Theme, tabsClasses } from '@mui/material';

export const MuiTab: { styleOverrides: ComponentsOverrides<Theme>['MuiTab'] } = {
    styleOverrides: {
        root: {
            height: 38,
            minHeight: 40,
            padding: '7px 24px 12px',
            fontSize: '15px',
            fontWeight: 400,
            letterSpacing: 'normal',
            boxShadow: 'none',
            '&:hover': {
                boxShadow: 'none',
            },
        },
    },
};

export const MuiTabs: { styleOverrides: ComponentsOverrides<Theme>['MuiTabs'] } = {
    styleOverrides: {
        root: {
            height: 40,
            minHeight: 40,

            // MUI suggests this implementation to make the arrows always visible
            // https://mui.com/material-ui/react-tabs/#forced-scroll-buttons
            [`& .${tabsClasses.scrollButtons}`]: {
                '&.Mui-disabled': { opacity: 0.3 },
            },
        },
    },
};
